import React, { useState } from "react";
import { Box, Typography, Dialog, DialogTitle, DialogContent, Button, Stack, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Ícono para cerrar
import { useNavigate } from "react-router-dom";

/**
 * UneteALaComunidad:
 * Versión simplificada: Botón directo que abre el popup de autenticación.
 */

const UneteALaComunidad = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAction = (path) => {
    setShowAuthModal(false);
    navigate(path);
  };

  return (
    <>
      <Box
        onClick={() => setShowAuthModal(true)}
        sx={{
          display: "flex",
          px: 3,
          py: 1,
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "transparent",
          borderRadius: "5px",
          border: "1px solid #F21C63",
          cursor: "pointer",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(242, 28, 99, 0.05)",
            boxShadow: "0px 2px 8px rgba(242, 28, 99, 0.2)"
          }
        }}
      >
        <Typography
          sx={{
            color: "#F21C63",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          Ingresar
        </Typography>
      </Box>

      {/* Modal de Autenticación */}
      <Dialog 
        open={showAuthModal} 
        onClose={() => setShowAuthModal(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "15px",
            padding: "10px",
            zIndex: 1000000
          }
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold", color: "#211E26" }}>
          ¿Cómo deseas continuar?
          <IconButton 
            onClick={() => setShowAuthModal(false)}
            sx={{ position: "absolute", right: 8, top: 8, color: "#999" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ textAlign: "center", color: "#666", mb: 3 }}>
            Selecciona si deseas crear una cuenta nueva o acceder con tus credenciales actuales.
          </Typography>
          <Stack spacing={2} sx={{ mb: 2 }}>
            <Button 
              fullWidth 
              variant="contained" 
              onClick={() => handleAction("/register")}
              sx={{ 
                backgroundColor: "#F21C63", 
                color: "#fff", 
                textTransform: "none", 
                fontWeight: "bold",
                borderRadius: "10px",
                height: "45px",
                "&:hover": { backgroundColor: "#d81856" }
              }}
            >
              Registrarse (Gratis)
            </Button>
            <Button 
              fullWidth 
              variant="outlined" 
              onClick={() => handleAction("/login")}
              sx={{ 
                borderColor: "#F21C63", 
                color: "#F21C63", 
                textTransform: "none", 
                fontWeight: "bold",
                borderRadius: "10px",
                height: "45px",
                "&:hover": { borderColor: "#d81856", backgroundColor: "rgba(242, 28, 99, 0.05)" }
              }}
            >
              Ya tengo cuenta / Acceder
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UneteALaComunidad;
